export default __webpack_public_path__ + "static/media/placeholder_portfolio02-it-mobile.e4a62df0.png";